import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Layout } from 'antd'
import RoutesComponent from './router/RoutesComponent'
import { UserProvider } from './utils/contexts/UserContext'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'

// 解构出布局组件
const { Content } = Layout

const App: React.FC = () => {
  return (
    <BrowserRouter basename="/">
      <ConfigProvider locale={zhCN}>
      <UserProvider>
        <Layout>
            <RoutesComponent />
        </Layout>
      </UserProvider>
      </ConfigProvider>
    </BrowserRouter>
  )
}

export default App
